import {
  GET_DASHBOARD_NEWS_LOADING,
  GET_DASHBOARD_NEWS_SUCCESS,
  GET_DASHBOARD_NEWS_ERROR,
} from "../../../constant/actionTypes";

const dashboardNewsReducer = (
  state = {
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case GET_DASHBOARD_NEWS_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_NEWS_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DASHBOARD_NEWS_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default dashboardNewsReducer;
